import { render, staticRenderFns } from "./Base600White.vue?vue&type=template&id=3acddc00&scoped=true&"
var script = {}
import style0 from "./Base600White.vue?vue&type=style&index=0&id=3acddc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acddc00",
  null
  
)

export default component.exports